import React from "react";
import "./style.scss";
import Footer from "../Footer";

const AppFooter = ({ backgroundColor }) => {
  return <Footer home={false} />;
};

export default AppFooter;
